import React, { useState, useRef } from 'react'
import { Icon, Input, Spin, Button, message, Tag, notification } from "antd"
import { receiveLazeCut } from '../../../services/api/3dApi'
import { handleBatchScanSubmit } from '../helper/handleBatchScanSubmit'

const InputReceiveLazeCut = () => {

    const _input = useRef()
    const [loading, setLoading] = useState(false)
    const [valueInput, setValueInput] = useState('')
    const [errorInput, setErrorInput] = useState('')
    const [listBatch, setListBatch] = useState([])

    const _onSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        try {
            await handleBatchScanSubmit({
                valueInput,
                listBatch,
                setListBatch,
                setErrorInput,
            })
        } catch (error) {
            setErrorInput(error.message || error)
        } finally {
            setLoading(false)
            setValueInput('')
            _input.current.focus()
        }
    }

    const _removeBatch = (batchId) => {
        setListBatch(prev => prev.filter(b => b._id !== batchId))
    }

    const _resetScanInput = () => {
        setValueInput('')
        _input.current.focus()
    }

    const _handleChangeScan = e => {
        setValueInput(e.target.value)
        setErrorInput('')
    }

    const _handleReceiveLazeCut = async () => {
        setLoading(true)

        try {
            const names = listBatch.map(b => b.name)
            const { data: response } = await receiveLazeCut({ names })
            const { success, data = [], error } = Object.assign({}, response)

            if (success) {
                const listSuccess = data.filter(item => item.success === true)
                const listError = data.filter(item => item.success === false)

                notification.open({
                    message: 'Kết quả nhận lô cắt laze',
                    description: (
                        <div>
                            {listSuccess.length > 0 && (
                                <div className="mt-2">
                                    <h5 className="text-success">Nhận lô cắt laze thành công:</h5>
                                    <ul className="pl-4 list-disc">
                                        {listSuccess.map(item => (
                                            <li key={item.name}>{item.name}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            {listError.length > 0 && (
                                <div className="mt-2">
                                    <h5 className="text-danger">Có lỗi khi nhận các lô:</h5>
                                    <ul className="pl-4 list-disc">
                                        {listError.map(item => (
                                            <li key={item.name}>{`${item.name}: ${item.error}`}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    ),
                    placement: 'topRight',
                    duration: 4.5,
                })
                setListBatch([])
            } else {
                message.error(error)
            }
            _resetScanInput()

        } catch (error) {
            message.error(error.message || error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="UpdateLazeCutting">
            <div className="UpdateLazeCuttingPage">
                <div className="position-relative">
                    <Spin spinning={loading} tip='Đang kiểm tra...'>
                        <form onSubmit={_onSubmit} className="formQC">
                            <Input
                                value={valueInput.toUpperCase()}
                                style={{ fontSize: 40, height: "auto" }}
                                ref={_input}
                                autoFocus={true}
                                placeholder='Nhập vào tên lô'
                                onChange={_handleChangeScan}
                            />

                            {
                                valueInput &&
                                <Icon
                                    type='close-circle'
                                    className="position-absolute cursor-pointer text-dark IconInput"
                                    onClick={_resetScanInput}
                                />
                            }

                            {
                                loading &&
                                <Icon type="sync" spin className="position-absolute IconInput" />
                            }

                            <div className="d-flex justify-content-between align-items-center">
                                <div className="batch_tag">
                                    {
                                        !!listBatch.length &&
                                        listBatch.map((batch) => (
                                            <Tag
                                                key={batch._id}
                                                closable
                                                onClose={() => _removeBatch(batch._id)}
                                            >{batch.name}
                                            </Tag>
                                        ))
                                    }
                                </div>
                                <div>
                                    {
                                        !loading && !!listBatch.length &&
                                        <Button
                                            type='primary'
                                            className='float-right mt-3 px-4'
                                            onClick={_handleReceiveLazeCut}
                                        >
                                            Nhận lô cắt laze
                                        </Button>
                                    }
                                </div>
                            </div>
                        </form>

                        {errorInput && <div className="text-danger mt-3">{errorInput}</div>}
                    </Spin>
                </div>
            </div>
        </div>
    )
}

export default InputReceiveLazeCut
